import { render } from "./quranPrograms.vue?vue&type=template&id=a723715e&scoped=true"
import script from "./quranPrograms.vue?vue&type=script&lang=js"
export * from "./quranPrograms.vue?vue&type=script&lang=js"

import "./quranPrograms.vue?vue&type=style&index=0&id=a723715e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a723715e"]])

export default __exports__